
import URI from 'urijs';
import get from 'lodash/get';

import {
    SET_PROJECT,
    SET_PROJECT_PARAM
} from '../sagas/setProject';
import { GET_PROJECT_ACTION_TYPE } from '../sagas/getProject';

const initialState = {
    accessDenied: false,
    project: null,
    projectParams: {}
};

function modifyProjectAddServerApiParam(project, projectParams) {
    let serverApiUrl = projectParams['SERVER_API_URL'];
    if (serverApiUrl) {
        if (project.multiSceneProject && project.multiSceneProject.url) {
            let uri = new URI(project.multiSceneProject.url);
            uri.setSearch('serverApiUrl', serverApiUrl);
            project.multiSceneProject.url = uri.toString();
        }
    }
    return project;
}

function modifyProjectFromUrl(project) {
    project.mapProject.defaultCenter = project.mapProject.center;
    project.mapProject.defaultZoom = project.mapProject.zoom;

    let uri = new URI(window.location.href);

    let x = uri.search(true).x;
    let y = uri.search(true).y;
    if (x && y) {
        project.mapProject.center = [parseFloat(x), parseFloat(y)];
    }

    let zoom = uri.search(true).zoom;
    if (zoom) {
        project.mapProject.zoom = parseInt(zoom);
    }

    let layers = uri.search(true).layers;
    if (layers) {
        project.mapProject.defaultVisibleLayers = layers.split(',');
    }

    return project;
}

function setProject(state, action) {
    let project = action.project;

    project = modifyProjectFromUrl(project);
    project = modifyProjectAddServerApiParam(project, state.projectParams);

    return {
        ...state,
        project: project
    };
}

function setProjectParam(state, action) {
    return {
        ...state,
        projectParams: {
            ...state.projectParams,
            [action.name]: action.value
        }
    };
}

export function getMapLayers(state) {
    return get(state, 'project.project.mapProject.layers');
}

export function getMapLayerById(state, layerId) {
    const mapLayers = getMapLayers(state);

    let mapLayer = null;
    mapLayers.forEach(item => {
        if (layerId.endsWith(item.id)) {
            mapLayer = item;
        }
    });
    return mapLayer;
}

export function getMapDataMapping(state) {
    let result = {data: {}, map: {}};
    getMapLayers(state).forEach(item => {
        if (item.attachedDataModel) {
            result.data[item.attachedDataModel] = item.id;
            result.map[item.id] = item.attachedDataModel;
        }
    });
    return result;
}

export function getMapLayerByAttachedDataModel(state, dataModelId) {
    return getMapLayers(state).reduce((previous, current) => {
        return (current.attachedDataModel === dataModelId)
            ? current
            : previous;
    }, null);
}

export function getDataProjectId(state) {
    return get(state, 'project.project.app.modules.data.projectId');
}

export function getReportProjectId(state) {
    return get(state, 'project.project.app.modules.print.projectId');
}

export function getSearchProjectId(state) {
    return get(state, 'project.project.app.modules.search.projectId');
}

function project(state = initialState, action) {
    switch (action.type) {
        case GET_PROJECT_ACTION_TYPE.DEFAULT:
            return {
                ...state,
                accessDenied: false
            };
        case GET_PROJECT_ACTION_TYPE.FAILED:
            return {
                ...state,
                accessDenied: (action.httpStatus === 401)
            };
        case SET_PROJECT:
            return setProject(state, action);
        case SET_PROJECT_PARAM:
            return setProjectParam(state, action);
        default:
            return state;
    }
}

export default project;
